import { Button, ButtonProps } from "antd";
import classNames from "classnames";
import { forwardRef } from "react";
import styles from "./index.module.less";

interface HBButtonProps extends ButtonProps {
  active?: boolean;
  theme?: "gray" | "black";
  bold?: boolean;
}

function RawHBButton(
  { className, shape, active, theme, bold, ...props }: HBButtonProps,
  ref
) {
  return (
    <Button
      {...props}
      className={classNames(styles.HBButton, className, {
        [styles.circle]: shape === "circle",
        [styles.active]: active,
        [styles.gray]: theme === "gray",
        [styles.black]: theme === "black",
        [styles.bold]: bold,
      })}
      shape={shape}
      ref={ref}
    />
  );
}

const HBButton = forwardRef(RawHBButton);

export default HBButton;
